<template>
  <transition name="modal">
    <div class="modal-mask" v-if="showModal">
      <div class="modal-wrapper">
        <div class="modal-container">
          <h3 class="similar-songs-text">Similar Songs</h3>
          <div class="song-list-progression">
            <div v-for="(item, index) in similarSongs" :key="index" class="song-card">
              <i class="fa-solid fa-guitar"></i>
              {{ item.artist }} -
              <a :href="item.url" target="_blank">&quot;{{ item.song }}&quot;</a>
            </div>
          </div>
          <button class="modal-close-button" @click="closeModal">×</button>
        </div>Í
      </div>
    </div>
  </transition>
</template>

<script>
import { chordStore } from "@/store/chordStore";

export default {
  computed: {
    showModal() {
      return chordStore.showSongs;
    },
    similarSongs() {
      return chordStore.similarSongs;
    },
  },
  methods: {
    closeModal() {
      chordStore.showSongs = false;
    },
  },
};
</script>





<style scoped>
@import "@/styles.css";
</style>
